import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { IconButton, Tooltip } from '@material-ui/core';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import React from 'react';
import { useRecoilValue } from 'recoil';

export default function IconSettingShowInDrilldown({
    field,
    fieldList,
    setFieldList,
    fieldAddList,
    setFieldAddList,
    setIsChangeData
}) {
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);

    if (!setFieldAddList || !setFieldList || Utils.isEmptyObject(projectInuseDetail)) return null;

    let isShowInDrilldown = true;
    let crrentHideInProject = Utils.convertJSONDataToObject(field?.hideInProject);
    if (crrentHideInProject) {
        isShowInDrilldown = crrentHideInProject[projectInuseDetail?.id] !== Constant.SHOW_FIELD_IN_DRILLDOWN.SHOW;
    }

    const onClickToggleFieldVisibility = () => {
        let fieldListClone = cloneDeep(fieldList);
        let fieldIndex = Utils.findIndexInArrayById(field.id, fieldListClone);

        if (fieldIndex !== -1) {
            let hideInProject =
                Utils.convertJSONDataToObject(fieldListClone[fieldIndex].hideInProject) || {};

            hideInProject[projectInuseDetail?.id] =
                hideInProject[projectInuseDetail?.id] === 1 ? 0 : 1;

            fieldListClone[fieldIndex].hideInProject = JSON.stringify(hideInProject);

            setFieldList(fieldListClone);
            setIsChangeData(true);

            let fieldAddListClone = cloneDeep(fieldAddList);
            let addFieldIndex = Utils.findIndexInArrayById(field.id, fieldAddListClone);

            if (addFieldIndex !== -1) {
                fieldAddListClone[addFieldIndex].hideInProject = JSON.stringify(hideInProject);
                setFieldAddList(fieldAddListClone);
            }
        }
    };

    return (
        <Tooltip
            title={I18n.get('LABEL-TOOLTIP-SHOW-FIELD-IN-DRILLDOWN')}
            placement="bottom"
            arrow
        >
            <IconButton
                className="itemTools"
                data-cy="item-field-icon-show-field-in-drilldown"
                onClick={event => {
                    event.stopPropagation();
                    onClickToggleFieldVisibility();
                }}
            >
                <img
                    src={
                        isShowInDrilldown
                            ? '/assets/image/eye-show.svg'
                            : '/assets/image/eye-hide.svg'
                    }
                    alt=""
                />
            </IconButton>
        </Tooltip>
    );
}
